export function getCssVariable(varName: string) {
  if (import.meta.env.JEST_WORKER_ID !== undefined) {
    return "";
  }
  const rootElement = document.getElementById("root") as HTMLDivElement;
  return getComputedStyle(rootElement).getPropertyValue(varName);
}
